// Add [data-notab] to any html element you don't want to be tabbable
import Dom from '../Utility/Dom';

const Modal = {
    open: function(target){
        for (let element of Dom.focusable) {
            element.setAttribute('tabindex', '-1');
            if(!element.hasAttribute('data-notab') && element.closest('.modal') == target){
                element.setAttribute('tabindex', '1');
            }
        }
        // Sometimes, target isn't a modal, so we'll make sure we're still getting things working there.
        const targetFocusEls = target.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]')
        targetFocusEls.forEach(element => {
          if(!element.hasAttribute('data-notab')){
              element.setAttribute('tabindex', '1');
          }
        })
    },
    close: function(target){
        for (let element of Dom.focusable) {
            if(element.hasAttribute('data-notab') || element.closest('.modal') == target){
                element.setAttribute('tabindex', '-1');
            }
            else {
                element.setAttribute('tabindex', '1');
            }
        }
        // Sometimes, target isn't a modal, so we'll make sure we're still getting things working there.
        const targetFocusEls = target.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]')
        targetFocusEls.forEach(element => {
          element.setAttribute('tabindex', '-1');
        });
    }
}


export default Modal;
